import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { FillType, IImageFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { IItems } from '../form.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

/**
 * 填充专项。填充区域需要隐藏的设置项。
 * @param model 所选元素
 * @returns
 */
export const getFillHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    const fillType = model.getBackgroundFill?.().getFillType();
    const fillInfo = model.getBackgroundFill?.().getCurrentFill()?.fillInfo;
    const isImageAllFill = fillType === FillType.ImageFill && !(fillInfo as IImageFill).tile;   // 图片填充-充满
    const isImageTileFill = fillType === FillType.ImageFill && (fillInfo as IImageFill).tile;   // 图片填充-平铺
    const isBackground = model.type === UIModelType.EMPTY;
    return {
        [FormItemName.SOLID_FILL_COLOR_TEXT]: () => fillType !== FillType.SolidFill,
        [FormItemName.SOLID_FILL_COLOR]: () => fillType !== FillType.SolidFill,
        [FormItemName.SOLID_FILL_OPACITY]: () => fillType !== FillType.SolidFill,
        [FormItemName.IMAGE_FILL_CLIPBOARD]: () => fillType !== FillType.ImageFill,
        [FormItemName.IMAGE_FILL_OPACITY]: () => fillType !== FillType.ImageFill,
        [FormItemName.IMAGE_FILL_UPLOAD]: () => fillType !== FillType.ImageFill,
        [FormItemName.IMAGE_FILL_STYLE]: () => fillType !== FillType.ImageFill,
        [FormItemName.GRADUAL_FILL_ANGLE]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_DIRECTION]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_ANGLE_TEXT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_DIRECTION_TEXT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_BAR]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_LINEAR_GRADIENT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_TYPE_TEXT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_RADIAL_GRADIENT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_RECT_GRADIENT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_SHAPE_GRADIENT]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_TITLE_GRADIENT]: () => !(fillType === FillType.GradualFill && isBackground),
        [FormItemName.GRADUAL_FILL_OPACITY]: () => fillType !== FillType.GradualFill,
        [FormItemName.GRADUAL_FILL_ROTATE_WITH_SHAPE]: () => fillType !== FillType.GradualFill,
        [FormItemName.IMAGE_FILL_ROTATE_WITH_SHAPE]: () => fillType !== FillType.ImageFill,
        [FormItemName.IMAGE_FILL_OFFSET_LEFT]: () => !isImageAllFill,
        [FormItemName.IMAGE_FILL_OFFSET_RIGHT]: () => !isImageAllFill,
        [FormItemName.IMAGE_FILL_OFFSET_TOP]: () => !isImageAllFill,
        [FormItemName.IMAGE_FILL_OFFSET_BOTTOM]: () => !isImageAllFill,
        [FormItemName.IMAGE_FILL_OFFSET_X]: () => !isImageTileFill,
        [FormItemName.IMAGE_FILL_OFFSET_Y]: () => !isImageTileFill,
        [FormItemName.IMAGE_FILL_SCALE_X]: () => !isImageTileFill,
        [FormItemName.IMAGE_FILL_SCALE_Y]: () => !isImageTileFill,

    };
};
